export default __webpack_public_path__ + "static/media/pic2.6863af4b.jpg";